import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "exclamation-icon"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "custom-day-week" }
const _hoisted_4 = { class: "icons" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "custom-month-year-component" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 0,
  class: "row p-2"
}
const _hoisted_11 = { class: "col-12" }
const _hoisted_12 = {
  key: 0,
  class: "datepicker-wrapper"
}
const _hoisted_13 = {
  key: 0,
  class: "exclamation-icon"
}
const _hoisted_14 = {
  key: 1,
  class: "angle-icon"
}
const _hoisted_15 = {
  key: 2,
  class: "angle-icon"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ExclamationIcon = _resolveComponent("ExclamationIcon")!
  const _component_AsahiButton = _resolveComponent("AsahiButton")!
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!
  const _component_AngleUpDownIcon = _resolveComponent("AngleUpDownIcon")!
  const _component_AngleLeftRightIcon = _resolveComponent("AngleLeftRightIcon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({'datepicker-wrapper datepicker-wrapper-mobile': _ctx.isMobile})
  }, [
    (_ctx.hasCalendarException && _ctx.isMobile)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
          _createVNode(_component_ExclamationIcon)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.isMobile ? 'datepicker-mobile-body': '')
    }, [
      _createVNode(_component_VueDatePicker, {
        class: _normalizeClass([_ctx.isCompact ? 'invert-filter' : '', _ctx.blackVersion ? 'black-version' : '', _ctx.hasCalendarException && !_ctx.isMobile ? 'has-calendar-exception' : '', !_ctx.isMobile ? 'delivery-date-picker-inner' : '']),
        modelValue: _ctx.deliveryDate,
        "onUpdate:modelValue": [
          _cache[1] || (_cache[1] = ($event: any) => ((_ctx.deliveryDate) = $event)),
          _ctx.onDateSelection
        ],
        ref: "vueDatePickerRef",
        "auto-apply": !_ctx.isMobile,
        "action-row": { showNow: false, showPreview: false },
        "enable-time-picker": false,
        "month-change-on-scroll": false,
        config: {keepActionRow: false, onClickOutside: false},
        "hide-offset-dates": true,
        "allowed-dates": _ctx.availableDates,
        locale: _ctx.localeValue,
        clearable: false,
        "min-date": _ctx.firstAvailableDate,
        "month-name-format": "long",
        format: "dd.MM.yyyy",
        "calendar-class-name": "custom-calendar",
        "menu-class-name": "custom-menu",
        "input-class-name": _ctx.inputClassName,
        "day-class": _ctx.getDayClass,
        markers: _ctx.markers,
        onFocus: _ctx.onCalendarOpen,
        onOpen: _ctx.onCalendarOpen,
        onClosed: _ctx.onCalendarClose,
        onBlur: _ctx.onCalendarClose,
        onUpdateMonthYear: _ctx.handleMonthYear,
        "teleport-center": _ctx.isMobile,
        "auto-position": false
      }, {
        "input-icon": _withCtx(() => [
          (!_ctx.isCompact)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _ctx.isMobile || _ctx.isCalnderInHome ? _ctx.CalendarIcon : _ctx.CalendarIconGold,
                alt: "Calendar icon"
              }, null, 8, _hoisted_2))
            : _createCommentVNode("", true)
        ]),
        "calendar-header": _withCtx(({ index }) => [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.dayOfWeek[index]), 1)
        ]),
        "month-year": _withCtx(({
            month,
            year,
            months,
            handleMonthYearChange
        }) => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", {
              class: "custom-icon",
              onClick: ($event: any) => (handleMonthYearChange(false))
            }, [
              _createElementVNode("img", {
                src: _ctx.ChevronLeftIcon,
                alt: "Chevron left icon"
              }, null, 8, _hoisted_6)
            ], 8, _hoisted_5),
            _createElementVNode("div", _hoisted_7, _toDisplayString(months !== undefined && month !== undefined ? months[month].text : '') + " " + _toDisplayString(year), 1),
            _createElementVNode("span", {
              class: "custom-icon",
              onClick: ($event: any) => (handleMonthYearChange(true))
            }, [
              _createElementVNode("img", {
                src: _ctx.ChevronRightIcon,
                alt: "Chevron right icon"
              }, null, 8, _hoisted_9)
            ], 8, _hoisted_8)
          ])
        ]),
        "action-extra": _withCtx(() => [
          (_ctx.isMobile)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_AsahiButton, {
                    type: "primary",
                    class: "w-100",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.saveChanges()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("Select")), 1)
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        "action-buttons": _withCtx(() => []),
        _: 1
      }, 8, ["class", "modelValue", "auto-apply", "allowed-dates", "locale", "min-date", "input-class-name", "day-class", "markers", "onFocus", "onOpen", "onClosed", "onBlur", "onUpdate:modelValue", "onUpdateMonthYear", "teleport-center"]),
      (_ctx.isMobile)
        ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
            (_ctx.hasCalendarException && !_ctx.isMobile)
              ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                  _createVNode(_component_ExclamationIcon)
                ]))
              : _createCommentVNode("", true),
            (!_ctx.isMobile)
              ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                  _createVNode(_component_AngleUpDownIcon, { up: _ctx.isOpen }, null, 8, ["up"])
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_15, [
                  _createVNode(_component_AngleLeftRightIcon, { right: true })
                ]))
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ], 2))
}